import React, {useEffect, useId} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {INVALID_EMAIL_TITLE} from 'client/StudentHomepage/invalidEmail.constants';
import {useStudentHomepageStore} from 'client/StudentHomepage/useStudentHomepageStore';
import {Button, Dialogue, Modal, Text} from '@albert-io/atomic';

const InvalidEmailModal = () => {
  const messageId = useId();
  const {setStudentHasInvalidEmail, studentEmail} = useStudentHomepageStore(
    useShallow((state) => ({
      setStudentHasInvalidEmail: state.setStudentHasInvalidEmail,
      studentEmail: state.studentEmail
    }))
  );

  useEffect(() => {
    return () => {
      setStudentHasInvalidEmail(false);
    };
  }, [setStudentHasInvalidEmail]);

  return (
    <Modal
      ariaDescribedBy={messageId}
      ariaLabel={INVALID_EMAIL_TITLE}
      handleClose={() => {
        setStudentHasInvalidEmail(false);
      }}
    >
      {({CloseButtonWrapper, modalContentStyle}) => (
        <Dialogue
          alignTitle='center'
          className={modalContentStyle}
          inModal
          hideCloseBtn
          stretchTitle
          title={INVALID_EMAIL_TITLE}
        >
          <Dialogue.Body className='text-center'>
            <div id={messageId}>
              <Text as='p'>
                The problem is your email, not the class code or invitation. This school only lets
                students join with a school email address.
              </Text>
              {studentEmail && (
                <Text as='p'>
                  You're signed in with{' '}
                  <Text as='span' bold className='break-words'>
                    {studentEmail}
                  </Text>
                  .
                </Text>
              )}
              <Text as='p'>
                Use your school email to join this class. If you're not sure which email that is,
                ask your teacher.
              </Text>
            </div>
          </Dialogue.Body>
          <div className='mt-x5 flex w-full'>
            <CloseButtonWrapper className='w-full'>
              <Button className='w-full' onClick={() => setStudentHasInvalidEmail(false)}>
                OK
              </Button>
            </CloseButtonWrapper>
          </div>
        </Dialogue>
      )}
    </Modal>
  );
};

export default InvalidEmailModal;
